module.exports = __webpack_public_path__ + "img/horizontal_4_5_9006.82b360af.png";